import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface HttpOptions {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  context?: HttpContext;
  observe?: 'body';
  params?:
    | HttpParams
    | {
        [param: string]:
          | string
          | number
          | boolean
          | ReadonlyArray<string | number | boolean>;
      };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  transferCache?:
    | {
        includeHeaders?: string[];
      }
    | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RestApiService {
  // TODO - when integrated with V2 this line needs to be deleted.
  backend_url: string = environment.apiUrl;
  token: any;
  mapOfColumnFilters = [];
  public configObj: any = {
    sortField: '',
    sortDirection: 'DESC',
    filterText: '',
    pageSize: 20,
    pageIndex: 0,
    filteredValues: [],
  };

  constructor(public http: HttpClient) {
    this.token = '';
  }

  public _addStandardHeaders(header: HttpHeaders) {
    header = header.append('Content-Type', 'application/json');
    header = header.append('Accept', 'application/json');
    header = header.append(
      'Access-Control-Allow-Methods',
      'GET, POST, DELETE, PUT'
    );

    return header;
  }

  get<T>(endpoint: string, options?: HttpOptions) {
    return this.http.get<T>(`${this.backend_url}/${endpoint}`, options);
  }

  // TODO - this line needs to be changed after v2 integration
  post<T>(endpoint: string, body: T) {
    return this.http.post<T>(`${this.backend_url}/${endpoint}`, body);
  }
}
